/**
 * 认证模块
 * 
 * 提供登录、登出等认证相关功能
 */

import type { WorkbenchModule } from '../types'

export const authModule: WorkbenchModule = {
  meta: {
    name: 'auth',
    title: '认证',
    description: '用户认证与登录管理',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/LoginView.vue'),
      meta: { title: '登录', public: true }
    }
  ],
  // 认证模块无需在侧边栏显示
  menuItem: undefined
}
